import { DeliveryMode, FulfillmentMode } from '@admin-panel/types';

/*
 * One vocabulary for a package's handling tags and badges (27 Oct): the cards' soft tags
 * (libs/pages orders/shared/PackageTags) and the package badges (packageBadges.tsx: desktop worklist,
 * order page, package page header) read their words from here. Sentence case; enum acronyms
 * (TEST, MTO, JIT, MTC, COD) stay as they are. Express minutes live in the Express banner.
 */
export const PACKAGE_LABELS = {
  express: 'Express',
  tryAtHome: 'Try at home',
  storePickup: 'Store pickup',
  homeDelivery: 'Home delivery',
  vendorShips: 'Vendor ships',
  giftWrap: 'Gift wrap',
  test: 'TEST',
} as const;

/** "Home delivery", "Store pickup"; any other mode in sentence case. */
export const deliveryModeLabel = (mode: DeliveryMode | string) =>
  mode === DeliveryMode.HOME_DELIVERY
    ? PACKAGE_LABELS.homeDelivery
    : mode === DeliveryMode.STORE_PICKUP
      ? PACKAGE_LABELS.storePickup
      : String(mode).charAt(0) + String(mode).slice(1).toLowerCase().replace(/_/g, ' ');

/** MTO, JIT, MTC as they are; on-hand stock is the default and gets no tag. */
export const fulfillmentModeLabel = (mode?: FulfillmentMode | string | null) =>
  mode && mode !== FulfillmentMode.ONHAND ? String(mode).replace(/_/g, ' ') : undefined;
